export default __webpack_public_path__ + "static/media/testimonial-image4.43429b07.jpeg";